export default __webpack_public_path__ + "static/media/Rectangle 61.4237498f.png";